<template>
  <v-card outlined class="mb-3">
    <v-card-text>
      <div
        class="subtitle-1 black--text font-weight-medium d-flex align-center"
      >
        <v-img :src="platform.logo_url" max-width="25px" class="mr-2"></v-img>
        Vimeo Settings
      </div>
      <div class="py-3 px-7">
        <v-row>
          <v-col cols="12" md="6" class="pb-0">
            <select-field
              label="Folders"
              @input="$emit('input', form)"
              v-model="form.vimeo_folder"
              :items="folders"
              multiple
            ></select-field>
          </v-col>
        </v-row>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>

import SelectField from "@/components/ui/form/SelectField.vue";
export default {
  components: { SelectField },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    post: {
      type: Object,
      default: () => ({}),
    },
    folders: Array,
    configuration: {
      type: Object,
    },
    isEditing: Boolean,
    isRepost: Boolean,
    isDraftPost: Boolean,
  },

  data() {
    return {
      form: {
        vimeo_folder: [],
      },
    };
  },
  watch: {

  },
  computed: {
    platform() {
      let platforms = this.$store.getters.flyPlatforms;
      let platform = platforms.find((i) => i.alias == "vimeo");
      return platform || {};
    },
  },
  methods: {
    initForm() {
      Object.keys(this.form).forEach((key) => {
        if (this.value[key] != undefined) {
          this.form[key] = this.value[key];
        }
      });
      if (!this.isEditing && this.folders.length == 1) {
        this.form.vimeo_folder = [this.folders[0].value];
        this.$emit("input", this.form);
      }
    },
    updateConfiguration() {
      this.form.vimeo_folder = this.configuration.vimeo_folder;
    },
  },
  beforeMount() {
    this.initForm();
    if (this.isEditing || this.isRepost || this.isDraftPost) {
      this.updateConfiguration();
    }
  },
};
</script>

<style></style>
